import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllClaims } from '../../store/action/claim';
import { Box, CircularProgress, Typography } from "@mui/material";
import { Bar } from 'react-chartjs-2';
import { makeStyles } from "@material-ui/core/styles";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from "chart.js";
import ChartDialog from "./ChartDialog";
import { translateClaimStatus } from "../../utils/translateStatus";
import Skeleton from "@mui/material/Skeleton";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const useStyles = makeStyles((theme) => ({
    chartContainer: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        borderRadius: '9px',
        padding: theme.spacing(2),
        height: '100%'
    },
    filterContainer: {
        display: 'flex',
        marginBottom: theme.spacing(2),
    },
    dateContainer: {
        margin: theme.spacing(0, 1),
        borderColor: 'rgba(225, 231, 236, 1)',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        padding: '5px 10px',
        '&::placeholder': {
            color: 'rgba(42, 46, 51, 1)',
        },
    },
}));

const ClaimsByStatus = (props) => {
    const classes = useStyles();

    const { claimData, loading, disableClick } = props;

    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedClaimStatus, setSelectedClaimStatus] = useState(null);

    const statusMap = (claimData || []).reduce((acc, item) => {
        acc[item.status] = item.count;
        return acc;
    }, {});

    const barData = {
        labels: Object.keys(statusMap).map((status) =>
            translateClaimStatus(status)
        ),
        datasets: [
            {
                label: 'Nombre des sinistres',
                data: Object.values(statusMap),
                backgroundColor: Object.keys(statusMap).map((_, index) =>
                    index % 2 === 0
                        ? 'rgba(60, 101, 86, 1)'
                        : 'rgba(240, 243, 199, 1)'
                ),
            },
        ],
    };

    const handleClick = (event, elements) => {
        if (disableClick || loading) return;

        if (elements.length > 0) {
            const index = elements[0].index;
            const status = Object.keys(statusMap)[index];
            setSelectedClaimStatus(status);
            setDialogOpen(true);
        }
    };

    return (
        <Box className={classes.chartContainer}>
            <Typography
                style={{
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginBottom: '10px',
                }}
            >
                Sinistres par statut
            </Typography>

            <Box height="250px">
                {loading ? (
                    <Skeleton variant="rectangular" height="100%" animation="wave" />
                ) : (
                    <Bar
                        data={barData}
                        options={{
                            indexAxis: 'y',
                            scales: {
                                x: { beginAtZero: true, grid: { display: false } },
                                y: { grid: { display: false } },
                            },
                            plugins: { legend: { display: false } },
                            barThickness: 8,
                            onClick: handleClick,
                        }}
                    />
                )}
            </Box>

            <ChartDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                claimStatusClaimsByStatus={selectedClaimStatus}
            />
        </Box>
    );
};


export default ClaimsByStatus;
